module.exports = __webpack_public_path__ + "img/sattelliteMap.ec55089d.png";